/**
 * Fetch Open Graph–style metadata for a URL (Microlink public API).
 * Falls back gracefully if the request fails (CORS, rate limit, invalid URL).
 */
export interface LinkPreviewResult {
  url: string;
  title?: string;
  description?: string;
  imageUrl?: string;
  siteName?: string;
}

export async function fetchLinkPreview(rawUrl: string): Promise<LinkPreviewResult | null> {
  const trimmed = rawUrl.trim();
  if (!trimmed) return null;

  let normalized = trimmed;
  if (!/^https?:\/\//i.test(normalized)) {
    normalized = `https://${normalized}`;
  }

  try {
    const u = new URL(normalized);
    const api = `https://api.microlink.io?url=${encodeURIComponent(u.toString())}`;
    const res = await fetch(api);
    if (!res.ok) return { url: u.toString(), title: u.hostname, siteName: u.hostname };

    const json = await res.json();
    const data = json?.data;
    if (!data) return { url: u.toString(), title: u.hostname, siteName: u.hostname };

    return {
      url: data.url || u.toString(),
      title: data.title || data.publisher || u.hostname,
      description: data.description,
      imageUrl: data.image?.url || data.logo?.url,
      siteName: data.publisher || data.logo?.url ? u.hostname : u.hostname,
    };
  } catch {
    try {
      const u = new URL(normalized);
      return { url: u.toString(), title: u.hostname, siteName: u.hostname };
    } catch {
      return null;
    }
  }
}
